// Legacy Socket.IO context — originally pointed at the BNB launchpad backend
// on Render. Slurp uses a different realtime path (`slurpWs` in lib/slurpApi),
// so this provider is now a no-op stub that keeps the consuming components
// happy without opening any sockets. Remove the remaining `useWebSocket()`
// call sites when the last BNB-era code path is gone.
import React, { createContext, useContext } from 'react';

const WebSocketContext = createContext(null);

const noop = () => {};

const STUB_VALUE = {
  socket: null,
  isConnected: false,
  connectionError: null,
  emit: noop,
  addListener: noop,
  removeListener: noop,
  reconnect: noop,
  silentReconnect: noop,
};

export const useWebSocket = () => useContext(WebSocketContext) || STUB_VALUE;

export const WebSocketProvider = ({ children }) => (
  <WebSocketContext.Provider value={STUB_VALUE}>
    {children}
  </WebSocketContext.Provider>
);

export default WebSocketContext;
